<div class="body-form-signin cubos-bg">
  <main class="form-register">

    <form class="form-shadow p-4">
      <div class="container justify-content-center">
        <div class="row justify-content-center">
          <div class="text-center">
            <a href="https://cubos.com"> <img class="mb-4" src="assets/images/cubos_cube_rgb.svg" alt="" width="72" height="57"> </a>
            <div class="col-md-12 col mb-2">
              <h3 class="font-weight-bold ml-md-0 mx-auto text-center" i18n="@@E-MailChangeConfirmationHeader">E-Mail Bestätigung</h3>
              <app-message [service]="messageService"></app-message>
              <ng-template #successMessage i18n="@@E-MailChangeSuccessMessage">
                Ihre E-Mail wurde erfolgreich bestätigt. Bitte <a [routerLink]="['/auth/login']" id="backtologin">klicken Sie hier, um sich einzuloggen.</a>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center round">
        <div class="col-lg-10 col-md-12">
          <div class="form-group">
            <div class="row justify-content-center">
              <div class="col-md-12 col-lg-10 col-12">
                <p class="mt-2 mb-3 text-center text-muted"><a href="https://www.cubos.com" style="text-decoration: none; color: #6c757d;">© {{currentYearLong()}} CUBOS Service GmbH</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </main>
</div>
